// Form is based on Formik
// Data validation is based on Yup
// Please, be familiar with article first:
// https://hackernoon.com/react-form-validation-with-formik-and-yup-8b76bda62e10

import React, { useEffect, useMemo } from "react";
import { Modal} from "react-bootstrap";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Formik, Form, Field,useField} from "formik";
import * as Yup from "yup";
import {useCountryUIContext} from "../CountryUIContext"
import {
  Input,
  Select,
  // DatePickerField,
} from "../../../../../../_metronic/_partials/controls";

  // Customers Redux state
  


const onOptionChangeHandler=async (e)=>{
  console.log(e);
  console.log(e.target.value);
};
// Validation schema
const CountryEditSchema = Yup.object().shape({
    name: Yup.string()
    .min(1, "Minimum 1 symbols")
    .max(50, "Maximum 50 symbols")
    .required("country Name is required"),
  countryCode: Yup.string()
    .min(2, "Minimum 2 symbols").
required("Country Code is required and should start with '+'").test("check prefix",function(){

            let blnum = this.parent["countryCode"];
            // console.log(carriercode, blnum);
            if (blnum) {
                return blnum.startsWith("+") ? true : false;
            }

}),
    
});
export function CountryCreateForm({
  saveCountry,
  country,
  actionsLoading,
  onHide,
  areas,
  countries



  
}) {
  return (
    <>
      <Formik
        enableReinitialize={true}
        initialValues={country}
        validationSchema={CountryEditSchema}
        onSubmit={(values) => {
            console.log('I am here',values);
          saveCountry(values);
        }}
      >
        {({ handleSubmit }) => (
          <>
            <Modal.Body className="overlay overlay-block cursor-default">
              {actionsLoading && (
                <div className="overlay-layer bg-transparent">
                  <div className="spinner spinner-lg spinner-success" />
                </div>
              )}
              <Form className="form form-label-right">
                <div className="form-group row">

                  <div className="col-lg-4">
                    <Field
                      name="countryCode"
                      component={Input}
                      placeholder="Country Code"
                      label="Country Code"
                    />
                  </div>
                  <div className="col-lg-4">
                  
                    <Field
                      name="name"
                      component={Input}
                      placeholder="Country Name"
                      label="Country Name"
                    />
                
                  </div>
                </div>
               
                 
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <button
                type="button"
                onClick={onHide}
                className="btn btn-light btn-elevate"
              >
                Cancel
              </button>
              <> </>
              <button
                type="submit"
                onClick={() => handleSubmit()}
                className="btn btn-primary btn-elevate"
              >
                Save
              </button>
            </Modal.Footer>
          </>
        )}
      </Formik>
    </>
  );
}
